import { render, staticRenderFns } from "./terms-of-user.component.vue?vue&type=template&id=772f7f76"
import script from "./terms-of-user.component.vue?vue&type=script&lang=js"
export * from "./terms-of-user.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports